import { useQueryClient } from 'react-query';
import { useEvent } from '../../../../hooks/useEvent';

export const useInvalidate = (key) => {
  const queryClient = useQueryClient();
  return useEvent(() => queryClient.invalidateQueries(key));
};
